module.exports = __webpack_public_path__ + "static/media/3.2be176af.jpg";